import { supabaseUrl } from '../lib/supabase'

const PUBLIC_OBJECT_PATH = '/storage/v1/object/public/'

// getPublicUrl() builds on supabaseUrl, which in production is the /api proxy on the
// current host. A stored public URL therefore carries whatever host it was uploaded
// from (a preview deployment, an old domain, a direct supabase.co URL), and breaks when
// that host isn't reachable from where it's shown. Re-point it at this host's
// supabaseUrl. Anything that isn't a Storage public URL (blob: previews, external
// images) is returned unchanged.
export const resolveStoragePublicUrl = (url: string): string => {
  const index = url.indexOf(PUBLIC_OBJECT_PATH)
  if (index === -1) return url
  return `${supabaseUrl.replace(/\/+$/, '')}${url.slice(index)}`
}
